/**
 * 主页路由
 */
const routerHome = [
  {
    path: '/home',
    name: 'Home',
    meta: {
      title: '首页',
      needLogin: false,
      transitionName: 'router',
      isTopMenu: true,
    },
    component: () => import('@/pages/module-home-new/index.vue'),
  },
  {
    path: '/data-guru',
    name: 'DataGuru',
    meta: {
      title: 'DataGuru',
      needLogin: true,
      transitionName: 'router',
      isTopMenu: false,
    },
    component: () => import('@/pages/module-chat/index.vue'),
  },
];

export default routerHome;
